import { render, staticRenderFns } from "./featuredProducts.vue?vue&type=template&id=09972a02&scoped=true&"
import script from "./featuredProducts.vue?vue&type=script&lang=js&"
export * from "./featuredProducts.vue?vue&type=script&lang=js&"
import style0 from "./featuredProducts.vue?vue&type=style&index=0&id=09972a02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09972a02",
  null
  
)

export default component.exports